import { RenderKatexToString } from '../LC/LCDocumentPresentation';
import { ILectioPlugin } from './Types';

const mathClass = 'lc-math-tex';

export class PluginLectioTexMath implements ILectioPlugin {
	public Init(): void {

		CKEDITOR.plugins.add('lectiotexmath', {
			requires: 'widget,dialog',
			icons:  'lectiotexmath',
			hidpi: true,
			init: initLectioMathTextPlugin,
		});
	}
}

type MathWidgetData = { math: string };
type MathWidget = { data: MathWidgetData };


const dialogdef: (editor: CKEDITOR.editor) => CKEDITOR.dialog.IDialogDefinition = editor => {
	let previewspan: CKEDITOR.dom.element | undefined;
	const lang = editor.lang.mathjax;

	return {
		title: lang.title,
		minWidth: 350,
		minHeight: 100,
		contents: [
			{
				id: 'info',
				elements: [
					{
						id: 'equation',
						type: 'textarea',
						label: lang.dialogInput,

						onLoad: function () {
							const that = this;

							this.getInputElement().on('keyup', () => {
								const tex = that.getInputElement().getValue();
								const mm = RenderKatexToString(tex);
								if (mm.type === 'ok') {
									previewspan!.setHtml(mm.value);
								} else {
									previewspan!.setHtml('Fejl under rendering af matematik.');
								}
							});
						},

						setup: function (widget) {
							const trimMathWrap = (rawtex: string) => rawtex.match(/^\\\(/) ? rawtex.substr(2, rawtex.length - 4) : rawtex;
							this.setValue(trimMathWrap(widget.data.math));
						},

						commit: function (widget) {
							// Vi gemmer matematikken med '\(' og '\)' omkring, fordi det gjortde ckeditors mathjax-matematik-plugin.
							widget.setData('math', '\\(' + this.getValue() + '\\)');
						}
					},
					{
						id: 'documentation',
						type: 'html',
						html:
							'<div style="width:100%;text-align:right;margin:-8px 0 10px">' +
							'<a class="cke_mathjax_doc" href="' + lang.docUrl + '" target="_black" style="cursor:pointer;color:#00B2CE;text-decoration:underline">' +
							lang.docLabel +
							'</a>' +
							'</div>'
					},
					{
						id: 'preview',
						type: 'html',
						html:
							'<div style="width:100%;text-align:center;">' +
							'<span class="lc-math-tex"></span>' +
							'</div>',

						onLoad: function () {
							const nn = CKEDITOR.document.getById((this as any).domId)!.getChild(0);
							if (!(nn instanceof CKEDITOR.dom.element))
								throw new Error("nn er ikke dom.element.");
							previewspan = nn;
						},

						setup: function (widget) {
							const mm = RenderKatexToString(widget.data.math);
							if (mm.type === 'ok') {
								previewspan!.setHtml(mm.value);
							} else {
								previewspan!.setHtml('Fejl under rendering af matematik.');
							}
						}
					}
				] as CKEDITOR.dialog.definition.uiElement<MathWidgetData>[]
			}
		] as CKEDITOR.dialog.definition.content[]
	};
}


function initLectioMathTextPlugin(this: 666, editor: CKEDITOR.editor) {
	const cls = mathClass || 'math-tex';

	editor.widgets.add<MathWidget>('lectiotexmath', {
		inline: true,
		dialog: 'lectiotexmath',
		button: editor.lang.mathjax.button,
		allowedContent: 'span(!' + cls + ')',
		// Allow style classes only on spans having mathjax class.
		styleToAllowedContentRules: (style: { getClassesArray: () => string[] }) => {
			const classes = style.getClassesArray();
			if (!classes)
				return null;
			classes.push('!' + cls);

			return 'span(' + classes.join(',') + ')';
		},
		pathName: editor.lang.mathjax.pathName,

		template: '<span class="' + cls + '" style="display:inline-block" data-cke-survive=1></span>',

		parts: {
			span: 'span'
		},

		defaults: {
			math: '\\(x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}\\)'
		},

		init: function () {
			return;
		},

		data: function (arg) {
			const mm = RenderKatexToString(arg.data.math);
			if (mm.type === 'ok') {
				this.element.setHtml(mm.value);
			} else {
				this.element.setHtml('Fejl under rendering af matematik.');
			}
		},

		upcast: (el, data) => {
			if (!(el.name == 'span' && el.hasClass(cls)))
				return;

			if (el.children.length > 1 || !(el.children[0] instanceof CKEDITOR.htmlParser.text))
				return;

			data.math = CKEDITOR.tools.htmlDecode(el.children[0].value);

			// Add style display:inline-block to have proper height of widget wrapper and mask.
			const attrs = el.attributes;

			if (attrs.style)
				attrs.style += ';display:inline-block';
			else
				attrs.style = 'display:inline-block';

			// Add attribute to prevent deleting empty span in data processing.
			attrs['data-cke-survive'] = 1;

			el.children[0].remove();

			return el;
		},

		downcast: function (el) {
			el.children[0].replaceWith(new CKEDITOR.htmlParser.text(CKEDITOR.tools.htmlEncode(this.data.math)));

			// Remove style display:inline-block.
			const attrs = el.attributes;
			attrs.style = attrs.style.replace(/display:\s?inline-block;?\s?/, '');
			if (attrs.style === '')
				delete attrs.style;

			return el;
		}
	});

	CKEDITOR.dialog.add('lectiotexmath', dialogdef);
}
